import './menu-styles.css.js';
import { useClassNames } from '@magnetic/hooks';
import React, { memo, forwardRef, Children } from 'react';
import { useNavContext } from '../nav-context.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const NavMenuListItem = /* @__PURE__ */ __name(({ children }) => /* @__PURE__ */ React.createElement("li", null, children), "NavMenuListItem");
const RenderNavMenu = /* @__PURE__ */ __name(({ children, className, ...props }, ref) => {
  const { isCollapsed, isIconOnly } = useNavContext();
  const classNames = useClassNames(
    "mds-rebuild-nav-menu",
    {
      "mds-rebuild-nav-menu-is-collapsed": isCollapsed,
      "mds-rebuild-nav-menu-is-icon-only": isIconOnly
    },
    className
  );
  return /* @__PURE__ */ React.createElement("ul", {
    ...props,
    className: classNames,
    ref
  }, Children.map(children, (child) => /* @__PURE__ */ React.createElement(NavMenuListItem, null, child)));
}, "RenderNavMenu");
const NavMenu = memo(forwardRef(RenderNavMenu));
NavMenu.displayName = "Nav.Menu";

export { NavMenu };
//# sourceMappingURL=index.js.map
